"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
var _interopRequireWildcard = require("reshow-runtime/helpers/interopRequireWildcard");
exports.__esModule = true;
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("reshow-runtime/helpers/objectSpread2"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("reshow-runtime/helpers/objectWithoutPropertiesLoose"));
var React = _interopRequireWildcard(require("react"));
var _classLib = require("class-lib");
var _SemanticUI = _interopRequireDefault(require("../molecules/SemanticUI.js"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "style"]; // @ts-check
/**
 * @param {{
 * className?: string,
 * style?: React.CSSProperties,
 * [key: string]: any
 * }} props
 */
var Content = function Content(_ref) {
  var className = _ref.className,
    style = _ref.style,
    props = (0, _objectWithoutPropertiesLoose2["default"])(_ref, _excluded);
  var classes = (0, _classLib.mixClass)(className, "content");
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SemanticUI["default"], (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
    ui: false
  }, props), {}, {
    className: classes,
    style: (0, _objectSpread2["default"])({
      boxSizing: "inherit"
    }, style)
  }));
};
var _default = exports["default"] = Content;
module.exports = exports.default;